import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_STRING: "array_string",
    OBJECT: "object",
};

const contexts = {
    EVENT: "event",
    SYSTEM: "system",
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class FormModuleAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(this.submitted());
    }

    submitted() {
        const e = AutomationEventTypes.FORM.SUBMITTED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Form Submitted", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.formId`, "Form ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.submissionId`, "Submission ID", vt.STRING),
            ]),
        ];
    }
}

export default FormModuleAttributeFactory;
